import { render, staticRenderFns } from "./recordAccountStatement.vue?vue&type=template&id=b7668c4a&"
import script from "./recordAccountStatement.vue?vue&type=script&lang=js&"
export * from "./recordAccountStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports